/* eslint-disable prefer-const */
/* eslint-disable no-useless-escape */
/* eslint-disable no-prototype-builtins */




export const YupValidationOptions = {
  shouldDirty: true,
  shouldTouch: true,
  shouldValidate: true,
};
export const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
export const tanRegex = /^[A-Z]{4}[0-9]{5}[A-Z]$/;

export const removeFirstSpace = (input = '') => input.replace(/^\s+/, '');

export const checkValidEmail = (email) => {
  if (
    email?.match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    )
  ) {
    return true;
  }
  return false;
};

export const mobileRegex = /^(?:(?:\+|0{0,2})91(\s*[\ -]\s*)?|[0]?)?[789]\d{9}|(\d[ -]?){10}\d$/;



export const findDuplicateInputs = (x, fieldName, stateData) => {
  if (
    stateData?.reduce((acc, curr) => {
      if (
        x?.[fieldName] &&
        curr?.[fieldName]?.toLowerCase() === x?.[fieldName]?.toLowerCase()
      ) {
        return acc + 1;
      }
      return acc;
    }, 0) > 1
  ) {
    return true;
  }
  return false;
};



export function addYearsToDate(inputDate, years) {
  // Convert inputDate to a Date object
  let date = new Date();
  if (inputDate) {
    date = new Date(inputDate);
  }

  // Add the specified number of years
  date.setFullYear(date.getFullYear() + years);

  // Format the resulting date as YYYY-MM-DD
  return date.toISOString().split('T')[0];
}


export function subtractYearsFromDate(inputDate, years) {
  // Convert inputDate to a Date object
  let date = new Date();
  if (inputDate) {
    date = new Date(inputDate);
  }

  // Subtract the specified number of years
  date.setFullYear(date.getFullYear() - years);

  // Format the resulting date as YYYY-MM-DD
  return date.toISOString().split('T')[0];
}

export function removeNonLetters(input) {
  const pattern = /[^a-zA-Z\s]+/g; // Match non-letters and non-spaces
  return input.replace(pattern, ''); // Replace with an empty string// Replace non-letter characters with an empty string
}

export function createSlug(name) {
  return name
    .toLowerCase()                          // Convert to lowercase
    .trim()                                 // Remove whitespace from both sides
    .replace(/[^a-z0-9\s-]/g, '')          // Remove special characters
    .replace(/\s+/g, '-')                   // Replace spaces with hyphens
    .replace(/-+/g, '-')                    // Replace multiple hyphens with a single one
    .slice(0, 50);                          // Limit slug length if necessary
}
export const onlyNumberInput = (input = 0) =>
  input
    .replace(/[^0-9]/g, '')
    .trim()
    .split(' ')
    .join('');

export const onlyNumberWithFlotingInput = (input = '0') =>
  input
    .replace(/[^0-9.]/g, '') // Allow only numbers and dots
    .replace(/^\./, '') // Remove dot if it's the first character
    .replace(/(\..{4})./g, '$1') // Allow only four characters after the dot
    .replace(/(\..*)\./g, '$1') // Allow only one dot
    .trim()
    .split(' ')
    .join('');

export const removeUnderScrSpCharSpaceBet = (pan = '') =>
  pan
    .replace(/[^a-zA-Z0-9]/g, '')
    ?.trim()
    .split(' ')
    .join('');

export default function removeSpecialChars(text) {
  return text.replace(/[^\w\s]/gi, ''); // Removes all non-word characters except spaces
}

export const removeSpecialCharAndNumFn = (input = '') =>
  input
    .trimStart() // Removes leading spaces from the start of the string
    .replace(/\s+/g, ' ')
    .replace(/([^a-zA-Z\s])/g, '');

export function checkTruthy(value) {
  return (
    value === true ||
    value === 1 ||
    (typeof value === 'string' && value.toUpperCase() === 'TRUE') ||
    (typeof value === 'string' && value.toUpperCase() === 'ACTIVE')
  );
}

export const removeUnderScrSpaceBet = (pan = '') =>
  pan?.trim().split(' ').join('');

export const replaceInputToValidPan = (pan) =>
  pan
    .replace(/[^\w\s]/gi, '')
    ?.trim()
    .split(' ')
    .join('')
    ?.toUpperCase();

export async function wrapWithTryCatch(fn) {
  return async function (...args) {
    try {
      return await fn.apply(this, args);
    } catch (error) {
      /* empty */
    }
    return args;
  };
}
export const removeAllSpaces = (value) => {
  if (typeof value !== 'string') return '';
  return value.replace(/\s+/g, '').trim();
};
export function sliceText(text = '', sliceNumber) {
  // Check if text is undefined or null, return empty string if true
  if (text == null) {
    return '';
  }

  // Convert text to string in case it is not
  text = String(text);

  // Check if sliceNumber is not provided or not a valid number
  if (typeof sliceNumber !== 'number' || sliceNumber <= 0) {
    return text;
  }

  // Slice the text to the specified number of characters
  return text?.slice(0, sliceNumber);
}
export const isString = (value) => typeof value === 'string';
export const toFixedValue = (value) => Math.round(value);

export function fillMissingNumbers(arr) {
  if (!arr?.length) {
    return [];
  }
  const result = [];
  let current = arr[0];

  for (const num of arr) {
    while (current < num) {
      result.push(current);
      current++;
    }
    result.push(num);
    current++;
  }

  return result;
}

export function createObjectWithKeys(inputObject, keysArray) {
  const outputObject = {};

  keysArray.forEach((key) => {
    if (inputObject.hasOwnProperty(key)) {
      outputObject[key] = inputObject[key];
    }
  });

  return outputObject;
}

export function handleUndefined(input) {
  if (input === undefined) {
    return '';
  }
  return input;
}

export const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth', // Optional: adds smooth scrolling animation
  });
};

export const isPlural = (number) => number > 1;
export const toUpperCase = (text) => (text ? `${text?.toUpperCase()}` : '');

export function isOlderThan58WithMonthCheck(dob) {
  // Convert the DOB string to a Date object
  const dobDate = new Date(dob);

  // Calculate the current date
  const currentDate = new Date();

  // Calculate the age difference in years
  const age = currentDate.getFullYear() - dobDate.getFullYear();

  // Check if the person is older than 58
  if (age > 58) {
    return true;
  } else if (age === 58) {
    // If the person is exactly 58 years old, check the month
    const currentMonth = currentDate.getMonth();
    const dobMonth = dobDate.getMonth();

    // Check if at least one month has passed since the last birthday
    return currentMonth > dobMonth;
  } else {
    return false;
  }
}

export function maskAccountNumber(accountNumber) {
  // Extract the last four digits
  const lastFourDigits = accountNumber.slice(-4);

  // Create a masked string with asterisks
  const maskedAccountNumber = `XXXXX${lastFourDigits}`;

  return maskedAccountNumber;
}
export function lastFourDigitsFn(accountNumber = '') {
  if (accountNumber.length < 4) {
    return 'N/A';
  }
  // Extract the last four digits
  const lastFourDigits = accountNumber.slice(-4);

  // Create a masked string with asterisks
  const maskedAccountNumber = `XXXX${lastFourDigits}`;

  return maskedAccountNumber;
}

export function sumProperty(arr, property) {
  const sumValue = parseNumericValue(
    arr?.reduce(
      (acc, cur) => {
        return parseNumericValue(acc) + parseNumericValue(cur[property]);
      },

      0,
    ),
  );

  return sumValue;
}

export const filteredNumbers = (mixedArray, property) =>
  mixedArray.filter((item) => {
    // Use parseFloat() or Number() to convert strings to numbers
    const num = parseFloat(item?.[property]);

    // Check if num is a finite number (not NaN) and not null
    return !isNaN(num) && num !== null;
  });
export function formatNumberToFixed(num) {
  // Check if the number is an integer
  if (Number.isInteger(num)) {
    return num;
  }
  // If not an integer, return up to 2 decimal places
  return parseFloat(num.toFixed(2));
}
export function parseNumericValue(input) {
  // If the input is null or undefined, return 0

  if (typeof input === 'number') {
    return input;
  }
  if (input === null || input === undefined) {
    return 0;
  }

  // If the input is a string, try to parse it as a number
  if (typeof input === 'string') {
    const parsedNumber = parseFloat(input);
    // If the parsing results in NaN, return 0
    if (isNaN(parsedNumber)) {
      return 0;
    }
    return Number(parsedNumber);
  }

  // If the input is already a number, return it

  // For any other type of input, return 0
  return 0;
}
export function parseOnlyNumericValue(input) {
  // If the input is null or undefined, return 0

  if (typeof input === 'number') {
    return input;
  }
  if (input === null || input === undefined) {
    return "";
  }

  // If the input is a string, try to parse it as a number
  if (typeof input === 'string') {
    const parsedNumber = parseFloat(input);
    // If the parsing results in NaN, return 0
    if (isNaN(parsedNumber)) {
      return "";
    }
    return Number(parsedNumber);
  }

  // If the input is already a number, return it

  // For any other type of input, return 0
  return "";
}
export function extractOnlyNumbers(input) {
  const match = input.match(/\d+/g);
  // Join the matched numbers (if any) and return, otherwise return "0"
  return match ? match.join('') : "";
}

export const landlinePattern = /(\d{2,4})[-\s]*(\d{6,8})/g;

export function formatLandline(input) {
  return input.replace(landlinePattern, (match, areaCode, mainNumber) => {
    // Standardizing the format to "XXXX-XXXXXXX"
    return `${areaCode}${mainNumber}`;
  });
}

export function parseOnlyNumericValueWithFirstZero(input) {
  // If the input is a number, return it if it's an integer
  if (typeof input === 'number') {
    return Number.isInteger(input) ? input : "";
  }

  // If the input is null or undefined, return an empty string
  if (input === null || input === undefined) {
    return "";
  }

  // If the input is a string, ensure it's a valid integer format
  if (typeof input === 'string') {
    // Match a string that is only digits or has leading zeroes (e.g., "0123"), disallowing decimal points
    const isValidInteger = /^0$|^[1-9]\d*$|^0\d+$/.test(input);
    if (!isValidInteger) {
      return "";
    }

    return parseInt(input, 10); // Parse and return as an integer
  }

  // For any other type of input, return an empty string
  return "";
}

export function parseNumericFloatValue(input) {
  // If the input is null or undefined, return 0

  if (typeof input === 'number') {
    return input;
  }
  if (input === null || input === undefined) {
    return 0;
  }

  // If the input is a string, try to parse it as a number
  if (typeof input === 'string') {
    const parsedNumber = parseFloat(input);

    // If the parsing results in NaN, return 0
    if (isNaN(parsedNumber)) {
      return 0;
    }
    return parsedNumber;
  }

  // If the input is already a number, return it

  // For any other type of input, return 0
  return 0;
}

export function parseNumericToFixedValue(input, fiexedValue = 2) {
  // If the input is null or undefined, return 0

  if (typeof input === 'number') {
    return input.toFixed(fiexedValue);
  }
  if (input === null || input === undefined) {
    return 0;
  }

  // If the input is a string, try to parse it as a number
  if (typeof input === 'string') {
    const parsedNumber = parseFloat(input);
    // If the parsing results in NaN, return 0
    if (isNaN(parsedNumber)) {
      return 0;
    }
    return Number(parsedNumber).toFixed(fiexedValue);
  }

  // If the input is already a number, return it

  // For any other type of input, return 0
  return 0;
}

export function toLowerCaseFn(input) {
  // Check if the input is undefined
  if (input === undefined) {
    return '';
  }

  // Ensure the input is a string before converting to lowercase
  if (typeof input === 'string') {
    return input.toLowerCase();
  }

  // If input is not a string, return an empty string
  return '';
}

export const hookformValidateObj = {
  shouldDirty: true,
  shouldTouch: true,
  shouldValidate: true,
};

export function extractErrorMessages(errors, limit = 5) {
  if (!errors) {
    return ''; // Return an empty string if errors is undefined or null
  }

  // If errors is a single object, convert it to an array with one element
  if (!Array.isArray(errors)) {
    errors = [errors];
  }

  const messages = errors.flatMap((errorObject) =>
    Object.values(errorObject).map((errorDetail) => errorDetail.message),
  );
  const limitedMessages = messages.slice(0, limit);

  return limitedMessages.join(', ');
}

export function getMonthInString(month) {
  let monthString = '';
  if (month === '0') {
    monthString = 'January, ';
  } else if (month === '1') {
    monthString = 'February, ';
  } else if (month === '2') {
    monthString = 'March, ';
  } else if (month === '3') {
    monthString = 'April, ';
  } else if (month === '4') {
    monthString = 'May, ';
  } else if (month === '5') {
    monthString = 'June, ';
  } else if (month === '6') {
    monthString = 'July, ';
  } else if (month === '7') {
    monthString = 'August, ';
  } else if (month === '8') {
    monthString = 'September, ';
  } else if (month === '9') {
    monthString = 'October, ';
  } else if (month === '10') {
    monthString = 'November, ';
  } else if (month === '11') {
    monthString = 'December, ';
  } else {
    monthString = '';
  }

  return monthString;
}

export function formatSlugText(input) {
  if (typeof input === 'undefined' || input === null) {
    return '';
  }
  return input.toLowerCase();
}

export function removeMultipleSpace(input = '') {
  const formattedString = input?.replace(/\s+/g, ' ')?.trimStart();
  return formattedString;
}

export function safeToString(value) {
  return value == null ? '' : String(value);
}

export function toCapitaliseString(str) {
  return str
    .split('')
    .map((char, index) => (index === 0 ? char.toUpperCase() : char))
    .join('');
}

export function replaceMultipleSpaces(input = '') {
  return input
    .trimStart() // Removes leading spaces from the start of the string
    .replace(/\s+/g, ' '); // Replaces multiple spaces with a
}

export const removeSpChar = (input = '') => input?.replace(/[^a-zA-Z0-9]/g, '');

export function generateUniqueId() {
  const now = Date.now(); // Get current date in milliseconds
  const random = Math.floor(Math.random() * 100000); // Generate a random number
  return `${now}-${random}`;
}

export const forOrganizationValidate = (input = '') =>
  input?.replace(/[^a-zA-Z0-9]/g, '');

export function safeTrim(value) {
  if (value === undefined || value === null) {
    return '';
  }
  return value.trim();
}

export const onlyAllowAtoZFn = (input = '') =>
  input
    .replace(/[^a-zA-Z]/g, '')


export const removeSpecialCharAndNumFn1 = (input = '') =>
  input
    .trimStart() // Removes leading spaces from the start of the string
    .replace(/\s+/g, ' ')
    .replace(/([^a-zA-Z\s])/g, '');



export function getDateProperFormatForInput(holidayDate) {
  if (holidayDate) {

    const date = new Date(holidayDate);

    if (!isNaN(date.getTime())) {
      return date.toISOString().substring(0, 10);
    }


  }
  return null;
}
export function getDateProperFormatForInputFn(holidayDate) {
  if (holidayDate) {
    const date = new Date(holidayDate);

    if (!isNaN(date.getTime())) {
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
      const year = String(date.getFullYear()) // Get the last two digits of the year

      return `${day}-${month}-${year}`;
    }
  }
  return null;
}

export function getDateProperFormatForInputReverseFn(holidayDate) {
  if (holidayDate) {
    const date = new Date(holidayDate);

    if (!isNaN(date.getTime())) {
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
      const year = String(date.getFullYear()) // Get the last two digits of the year

      return `${year}-${month}-${day}`;
    }
  }
  return null;
}

export function pickProperties(obj, keys) {
  return keys.reduce((result, key) => {
    if (obj.hasOwnProperty(key)) {
      result[key] = obj[key];
    }
    return result;
  }, {});
}

export function formatToCustomDate(date = new Date()) {
  const day = date.getDate();
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const month = monthNames[date.getMonth()];
  const year = date.getFullYear();

  // Determine the ordinal suffix (st, nd, rd, th)
  const ordinalSuffix = (n) => {
    if (n > 3 && n < 21) return "th";
    switch (n % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };

  return `${day}${ordinalSuffix(day)} ${month}, ${year}`;
}

export function formatToDDMMYYYY(date = new Date()) {
  const day = String(date?.getDate()).padStart(2, '0'); // Ensures 2-digit day
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
  const year = date.getFullYear(); // 4-digit year

  return `${day}/${month}/${year}`;
}

export function formatToYYYYMMDD(date = new Date()) {
  const day = String(date.getDate()).padStart(2, '0'); // Ensures 2-digit day
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
  const year = date.getFullYear(); // 4-digit year

  return `${year}-${month}-${day}`;
}

export const getInputFieldProps = ({ name, type, stateValues = {}, error, handleChangeFunction, handleBlurFn, index }) => {
  const inputProps = {
    onChange: (event) => handleChangeFunction(event, name, index),

  }

  if (handleBlurFn) {
    inputProps.onBlur = (event) => handleBlurFn(event, name, index);

  }
 



  if (type == 'checkbox') {
    inputProps.checked = !!stateValues?.[name]
  } else {


    if (stateValues?.[name]) {
      inputProps.value = stateValues?.[name];
      inputProps.defaultValue = stateValues?.[name];

      inputProps.valueSinc = !!stateValues?.[name];
    }
    else if (typeof stateValues?.[name] === 'boolean') {
      inputProps.value = !!stateValues?.[name];
      inputProps.defaultValue = !!stateValues?.[name];

      inputProps.valueSinc = !!stateValues?.[name];
    }

  };

  if (type ==="date" ) {
    
    inputProps.onKeyDown=e=>e.preventDefault()
    inputProps.valueSinc=true;
    if (stateValues?.[name]) {
    inputProps.value=getDateProperFormatForInput(stateValues?.[name]);
    }
    
    
  }
  if (error) {
    inputProps.error = error;
    inputProps.helperText = error;

  }
  return inputProps;
};

export function parseOnlyNumericValueForLandline(input) {
  if (input === 0) {
    return "0";
  }
  if (input === null || input === undefined) {
    return "";
  }
  if (typeof input === 'number') {
    return input.toString();
  }
  return input.replace(/[^0-9]/g, "");
}
export function getErrorDetailsFn(err) {


  const errorRes = {
    type: "UnknownError",
    message: "Something went wrong",
    details: err,
    errorObj: {}
  }

  // Check for network or fetch-related errors
  if (err.name === "TypeError" && err.message.includes("NetworkError")) {
    errorRes.message = "Network error occurred. Please try again later.";
    return errorRes;
  }

  // Handle Joi validation errors separately
  if (err?.type === "JoiValidationError" && err.errors) {



    const errorsAll = {};


    err.errors?.map((curr) => {
      const { field, message } = curr;

      errorsAll[field] = message;


    });

    if (Object.keys(errorsAll).length > 0) {

      errorRes.message = "Validation Error!";
    }
    errorRes.errorObj = errorsAll;
    return errorRes;
  }

  // Handle GeneralError specifically (e.g., invalid credentials or general failures)
  if (err?.type === "GeneralError") {
    errorRes.message = typeof err.message === 'string' ? err.message : "An unknown general error occurred."
    errorRes.details = err.details || "No further details provided."
    errorRes.type = "GeneralError"
    return errorRes;
  }

  // If it's an HTTP response error, extract status and message if available
  if (err?.response) {
    errorRes.message =
      err.response?.data?.message || "An error occurred on the server.";
  }

  // Return or throw structured error
  return errorRes;
}

export const removeExtraSpace = (pan = '') =>
  pan
    .trim()
    .replace(/\s+/g, '');
export const removeExtraSpace2 = (pan = '') =>
  pan
    .trim()
    .replace(/[^a-zA-Z0-9 ]/g, '') // Remove special characters
    .replace(/\s+/g, ' ');        // Allow only one space

export const shortFormName = (name) => {
  // Split the name into words
  const words = name.trim().split(/\s+/);

  // If there's only one word, return the first character
  if (words.length === 1) {
    return words[0].charAt(0).toUpperCase();
  }

  // If there are more than three words, return initials of the first three words
  if (words.length > 3) {
    return words.slice(0, 3).map(word => word.charAt(0).toUpperCase()).join('');
  }

  // Otherwise, return initials of all words
  return words.map(word => word.charAt(0).toUpperCase()).join('');
}

export const capitalize = (str) => str?.charAt(0).toUpperCase() + str?.slice(1).toLowerCase();

export const emailRegex = /^[a-zA-Z0-9]+([._%+-]?[a-zA-Z0-9]+)*@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/


export const getDay = (date)=>{
  const inputDate = new Date(date);

  if (isNaN(inputDate)) {
    return "Invalid Date";
  }

  const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

  const dayIndex = inputDate.getDay();

  return days[dayIndex];
}

export function toCapitaliseStringType1(str) {
  if (!str) return "";
  return str
    .split('')
    .map((char, index) => (index === 0 ? char.toUpperCase() : char))
    .join('');
}
export function toCapitaliseAllString(str) {
  return str
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

export const getDateProperFormatForInputType2 = (date) => {
  if (!date) return null;
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};
export const getDayName = (dayNumber) => {
  const days = {
    1: 'Sunday',
    2: 'Monday',
    3: 'Tuesday',
    4: 'Wednesday',
    5: 'Thursday',
    6: 'Friday',
    7: 'Saturday'
  };
  return days[dayNumber] || 'N/A';
};
export function getMonthInStringNotOneIndexBased(month) {
  let monthString = '';
  if (month === 1) {
    monthString = 'January, ';
  } else if (month === 2) {
    monthString = 'February, ';
  } else if (month === 3) {
    monthString = 'March, ';
  } else if (month === 4) {
    monthString = 'April, ';
  } else if (month === 5) {
    monthString = 'May, ';
  } else if (month === 6) {
    monthString = 'June, ';
  } else if (month === 7) {
    monthString = 'July, ';
  } else if (month === 8) {
    monthString = 'August, ';
  } else if (month === 9) {
    monthString = 'September, ';
  } else if (month === 10) {
    monthString = 'October, ';
  } else if (month === 11) {
    monthString = 'November, ';
  } else if (month === 12) {
    monthString = 'December, ';
  } else {
    monthString = '';
  }

  return monthString;
}
export function formatIndianCurrency(amount) {
  let [integer, decimal] = amount.toString().split(".");
  integer = integer.replace(/\B(?=(\d{2}){0,2}(\d{3})(?!\d))/g, ",");

  return decimal !== undefined ? `${integer}.${decimal}` : `${integer}`;
}

const qualifications = [
  { id: "0001", name: "Non Educated" },
  { id: "0002", name: "Basic Education" },
  { id: "0003", name: "8th Standard" },
  { id: "0004", name: "10th Standard" },
  { id: "0005", name: "12th Standard" },
  { id: "0006", name: "Diploma" },
  { id: "0007", name: "Bachelor Degree" },
  { id: "0008", name: "Master Degree" },
  { id: "0009", name: "Doctor of Medicine" },
  { id: "0010", name: "Chartered Accountant" },
  { id: "0011", name: "Civil Engineering" },
  { id: "0012", name: "Mechanical Engineering" },
  { id: "0013", name: "Electrical Engineering" },
  { id: "0014", name: "Computer Science Engineering" },
  { id: "0015", name: "Bachelor of Engineering (BE)" },
  { id: "0016", name: "Bachelor of Technology (BTech)" },
  { id: "0017", name: "Information Technology (IT)" },
  { id: "0018", name: "Engineering" },
  { id: "0019", name: "Robotics & Automation" },
  { id: "0020", name: "PhD" },
];

export const getQualificationName = (id) => {
  const qualification = qualifications.find((q) => q.id === id);
  return qualification ? qualification.name : "N/A";
};
export function getMonthInStringNotOneIndexBasedNew(month) {
  let monthString = '';
  if (month === 1) {
    monthString = 'January';
  } else if (month === 2) {
    monthString = 'February';
  } else if (month === 3) {
    monthString = 'March';
  } else if (month === 4) {
    monthString = 'April';
  } else if (month === 5) {
    monthString = 'May';
  } else if (month === 6) {
    monthString = 'June';
  } else if (month === 7) {
    monthString = 'July';
  } else if (month === 8) {
    monthString = 'August';
  } else if (month === 9) {
    monthString = 'September';
  } else if (month === 10) {
    monthString = 'October';
  } else if (month === 11) {
    monthString = 'November';
  } else if (month === 12) {
    monthString = 'December';
  } else {
    monthString = '';
  }
  return monthString;
}
export function getMonthInStringZeroIndexBased(month) {
  let monthString = '';
  if (month === 0) {
    monthString = 'January';
  } else if (month === 1) {
    monthString = 'February';
  } else if (month === 2) {
    monthString = 'March';
  } else if (month === 3) {
    monthString = 'April';
  } else if (month === 4) {
    monthString = 'May';
  } else if (month === 5) {
    monthString = 'June';
  } else if (month === 6) {
    monthString = 'July';
  } else if (month === 7) {
    monthString = 'August';
  } else if (month === 8) {
    monthString = 'September';
  } else if (month === 9) {
    monthString = 'October';
  } else if (month === 10) {
    monthString = 'November';
  } else if (month === 11) {
    monthString = 'December';
  } else {
    monthString = '';
  }
  return monthString
}